import CityPage from "../CityPage";

export default function Plainfield() {
  return <CityPage slug="plainfield" />;
}
